import { useTranslation } from "react-i18next";
import Reveal from "@/components/base/Reveal";

export default function Curriculum() {
  const { t } = useTranslation();

  return (
    <section id="curriculum" className="relative bg-midnight py-24 md:py-36">
      <div className="w-full px-6 md:px-12 lg:px-16">
        <Reveal>
          <div className="text-center max-w-4xl mx-auto">
            <span className="inline-block px-4 py-1.5 border border-champagne/40 rounded-full text-champagne text-xs font-sans tracking-widest uppercase mb-8">
              {t("curriculum.tag")}
            </span>
            <h2 className="text-marble font-serif text-2xl md:text-3xl lg:text-4xl font-light leading-snug tracking-wide whitespace-pre-line">
              {t("curriculum.title")}
            </h2>
            <p className="mt-6 text-champagne font-serif text-base md:text-lg lg:text-xl font-light leading-snug tracking-wide">
              {t("curriculum.subtitle")}
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}